export default __webpack_public_path__ + "static/media/9711-memomx.a6b2895c.pdf";